var colorUtil = {
	"colorList": [
		[0.0000000,0.0000,0.0000,0.0],
		[0.0019569,0.0000,0.0000,1.0],
		[0.0039139,0.0000,0.0627,0.0],
		[0.0058708,0.0000,0.0627,1.0],
		[0.0078278,0.0000,0.1255,0.0],
		[0.0097847,0.0000,0.1255,1.0],
		[0.0117417,0.0000,0.1882,0.0],
		[0.0136986,0.0000,0.1882,1.0],
		[0.0156556,0.0000,0.2510,0.0],
		[0.0176125,0.0000,0.2510,1.0],
		[0.0195695,0.0000,0.3137,0.0],
		[0.0215264,0.0000,0.3137,1.0],
		[0.0234834,0.0000,0.3765,0.0],
		[0.0254403,0.0000,0.3765,1.0],
		[0.0273973,0.0000,0.4392,0.0],
		[0.0293542,0.0000,0.4392,1.0],
		[0.0313112,0.0000,0.5020,0.0],
		[0.0332681,0.0000,0.5020,1.0],
		[0.0352250,0.0000,0.5647,0.0],
		[0.0371820,0.0000,0.5647,1.0],
		[0.0391389,0.0000,0.6275,0.0],
		[0.0410959,0.0000,0.6275,1.0],
		[0.0430528,0.0000,0.6902,0.0],
		[0.0450098,0.0000,0.6902,1.0],
		[0.0469667,0.0000,0.7529,0.0],
		[0.0489237,0.0000,0.7529,1.0],
		[0.0508806,0.0000,0.8157,0.0],
		[0.0528376,0.0000,0.8157,1.0],
		[0.0547945,0.0000,0.8784,0.0],
		[0.0567515,0.0000,0.8784,1.0],
		[0.0587084,0.0000,0.9412,0.0],
		[0.0606654,0.0000,0.9412,1.0],
		[0.0626223,0.0627,0.0000,0.0],
		[0.0645793,0.0627,0.0000,1.0],
		[0.0665362,0.0627,0.0627,0.0],
		[0.0684932,0.0627,0.0627,1.0],
		[0.0704501,0.0627,0.1255,0.0],
		[0.0724070,0.0627,0.1255,1.0],
		[0.0743640,0.0627,0.1882,0.0],
		[0.0763209,0.0627,0.1882,1.0],
		[0.0782779,0.0627,0.2510,0.0],
		[0.0802348,0.0627,0.2510,1.0],
		[0.0821918,0.0627,0.3137,0.0],
		[0.0841487,0.0627,0.3137,1.0],
		[0.0861057,0.0627,0.3765,0.0],
		[0.0880626,0.0627,0.3765,1.0],
		[0.0900196,0.0627,0.4392,0.0],
		[0.0919765,0.0627,0.4392,1.0],
		[0.0939335,0.0627,0.5020,0.0],
		[0.0958904,0.0627,0.5020,1.0],
		[0.0978474,0.0627,0.5647,0.0],
		[0.0998043,0.0627,0.5647,1.0],
		[0.1017613,0.0627,0.6275,0.0],
		[0.1037182,0.0627,0.6275,1.0],
		[0.1056751,0.0627,0.6902,0.0],
		[0.1076321,0.0627,0.6902,1.0],
		[0.1095890,0.0627,0.7529,0.0],
		[0.1115460,0.0627,0.7529,1.0],
		[0.1135029,0.0627,0.8157,0.0],
		[0.1154599,0.0627,0.8157,1.0],
		[0.1174168,0.0627,0.8784,0.0],
		[0.1193738,0.0627,0.8784,1.0],
		[0.1213307,0.0627,0.9412,0.0],
		[0.1232877,0.0627,0.9412,1.0],
		[0.1252446,0.1255,0.0000,0.0],
		[0.1272016,0.1255,0.0000,1.0],
		[0.1291585,0.1255,0.0627,0.0],
		[0.1311155,0.1255,0.0627,1.0],
		[0.1330724,0.1255,0.1255,0.0],
		[0.1350294,0.1255,0.1255,1.0],
		[0.1369863,0.1255,0.1882,0.0],
		[0.1389432,0.1255,0.1882,1.0],
		[0.1409002,0.1255,0.2510,0.0],
		[0.1428571,0.1255,0.2510,1.0],
		[0.1448141,0.1255,0.3137,0.0],
		[0.1467710,0.1255,0.3137,1.0],
		[0.1487280,0.1255,0.3765,0.0],
		[0.1506849,0.1255,0.3765,1.0],
		[0.1526419,0.1255,0.4392,0.0],
		[0.1545988,0.1255,0.4392,1.0],
		[0.1565558,0.1255,0.5020,0.0],
		[0.1585127,0.1255,0.5020,1.0],
		[0.1604697,0.1255,0.5647,0.0],
		[0.1624266,0.1255,0.5647,1.0],
		[0.1643836,0.1255,0.6275,0.0],
		[0.1663405,0.1255,0.6275,1.0],
		[0.1682975,0.1255,0.6902,0.0],
		[0.1702544,0.1255,0.6902,1.0],
		[0.1722114,0.1255,0.7529,0.0],
		[0.1741683,0.1255,0.7529,1.0],
		[0.1761252,0.1255,0.8157,0.0],
		[0.1780822,0.1255,0.8157,1.0],
		[0.1800391,0.1255,0.8784,0.0],
		[0.1819961,0.1255,0.8784,1.0],
		[0.1839530,0.1255,0.9412,0.0],
		[0.1859100,0.1255,0.9412,1.0],
		[0.1878669,0.1882,0.0000,0.0],
		[0.1898239,0.1882,0.0000,1.0],
		[0.1917808,0.1882,0.0627,0.0],
		[0.1937378,0.1882,0.0627,1.0],
		[0.1956947,0.1882,0.1255,0.0],
		[0.1976517,0.1882,0.1255,1.0],
		[0.1996086,0.1882,0.1882,0.0],
		[0.2015656,0.1882,0.1882,1.0],
		[0.2035225,0.1882,0.2510,0.0],
		[0.2054795,0.1882,0.2510,1.0],
		[0.2074364,0.1882,0.3137,0.0],
		[0.2093933,0.1882,0.3137,1.0],
		[0.2113503,0.1882,0.3765,0.0],
		[0.2133072,0.1882,0.3765,1.0],
		[0.2152642,0.1882,0.4392,0.0],
		[0.2172211,0.1882,0.4392,1.0],
		[0.2191781,0.1882,0.5020,0.0],
		[0.2211350,0.1882,0.5020,1.0],
		[0.2230920,0.1882,0.5647,0.0],
		[0.2250489,0.1882,0.5647,1.0],
		[0.2270059,0.1882,0.6275,0.0],
		[0.2289628,0.1882,0.6275,1.0],
		[0.2309198,0.1882,0.6902,0.0],
		[0.2328767,0.1882,0.6902,1.0],
		[0.2348337,0.1882,0.7529,0.0],
		[0.2367906,0.1882,0.7529,1.0],
		[0.2387476,0.1882,0.8157,0.0],
		[0.2407045,0.1882,0.8157,1.0],
		[0.2426614,0.1882,0.8784,0.0],
		[0.2446184,0.1882,0.8784,1.0],
		[0.2465753,0.1882,0.9412,0.0],
		[0.2485323,0.1882,0.9412,1.0],
		[0.2504892,0.2510,0.0000,0.0],
		[0.2524462,0.2510,0.0000,1.0],
		[0.2544031,0.2510,0.0627,0.0],
		[0.2563601,0.2510,0.0627,1.0],
		[0.2583170,0.2510,0.1255,0.0],
		[0.2602740,0.2510,0.1255,1.0],
		[0.2622309,0.2510,0.1882,0.0],
		[0.2641879,0.2510,0.1882,1.0],
		[0.2661448,0.2510,0.2510,0.0],
		[0.2681018,0.2510,0.2510,1.0],
		[0.2700587,0.2510,0.3137,0.0],
		[0.2720157,0.2510,0.3137,1.0],
		[0.2739726,0.2510,0.3765,0.0],
		[0.2759295,0.2510,0.3765,1.0],
		[0.2778865,0.2510,0.4392,0.0],
		[0.2798434,0.2510,0.4392,1.0],
		[0.2818004,0.2510,0.5020,0.0],
		[0.2837573,0.2510,0.5020,1.0],
		[0.2857143,0.2510,0.5647,0.0],
		[0.2876712,0.2510,0.5647,1.0],
		[0.2896282,0.2510,0.6275,0.0],
		[0.2915851,0.2510,0.6275,1.0],
		[0.2935421,0.2510,0.6902,0.0],
		[0.2954990,0.2510,0.6902,1.0],
		[0.2974560,0.2510,0.7529,0.0],
		[0.2994129,0.2510,0.7529,1.0],
		[0.3013699,0.2510,0.8157,0.0],
		[0.3033268,0.2510,0.8157,1.0],
		[0.3052838,0.2510,0.8784,0.0],
		[0.3072407,0.2510,0.8784,1.0],
		[0.3091977,0.2510,0.9412,0.0],
		[0.3111546,0.2510,0.9412,1.0],
		[0.3131115,0.3137,0.0000,0.0],
		[0.3150685,0.3137,0.0000,1.0],
		[0.3170254,0.3137,0.0627,0.0],
		[0.3189824,0.3137,0.0627,1.0],
		[0.3209393,0.3137,0.1255,0.0],
		[0.3228963,0.3137,0.1255,1.0],
		[0.3248532,0.3137,0.1882,0.0],
		[0.3268102,0.3137,0.1882,1.0],
		[0.3287671,0.3137,0.2510,0.0],
		[0.3307241,0.3137,0.2510,1.0],
		[0.3326810,0.3137,0.3137,0.0],
		[0.3346380,0.3137,0.3137,1.0],
		[0.3365949,0.3137,0.3765,0.0],
		[0.3385519,0.3137,0.3765,1.0],
		[0.3405088,0.3137,0.4392,0.0],
		[0.3424658,0.3137,0.4392,1.0],
		[0.3444227,0.3137,0.5020,0.0],
		[0.3463796,0.3137,0.5020,1.0],
		[0.3483366,0.3137,0.5647,0.0],
		[0.3502935,0.3137,0.5647,1.0],
		[0.3522505,0.3137,0.6275,0.0],
		[0.3542074,0.3137,0.6275,1.0],
		[0.3561644,0.3137,0.6902,0.0],
		[0.3581213,0.3137,0.6902,1.0],
		[0.3600783,0.3137,0.7529,0.0],
		[0.3620352,0.3137,0.7529,1.0],
		[0.3639922,0.3137,0.8157,0.0],
		[0.3659491,0.3137,0.8157,1.0],
		[0.3679061,0.3137,0.8784,0.0],
		[0.3698630,0.3137,0.8784,1.0],
		[0.3718200,0.3137,0.9412,0.0],
		[0.3737769,0.3137,0.9412,1.0],
		[0.3757339,0.3765,0.0000,0.0],
		[0.3776908,0.3765,0.0000,1.0],
		[0.3796477,0.3765,0.0627,0.0],
		[0.3816047,0.3765,0.0627,1.0],
		[0.3835616,0.3765,0.1255,0.0],
		[0.3855186,0.3765,0.1255,1.0],
		[0.3874755,0.3765,0.1882,0.0],
		[0.3894325,0.3765,0.1882,1.0],
		[0.3913894,0.3765,0.2510,0.0],
		[0.3933464,0.3765,0.2510,1.0],
		[0.3953033,0.3765,0.3137,0.0],
		[0.3972603,0.3765,0.3137,1.0],
		[0.3992172,0.3765,0.3765,0.0],
		[0.4011742,0.3765,0.3765,1.0],
		[0.4031311,0.3765,0.4392,0.0],
		[0.4050881,0.3765,0.4392,1.0],
		[0.4070450,0.3765,0.5020,0.0],
		[0.4090020,0.3765,0.5020,1.0],
		[0.4109589,0.3765,0.5647,0.0],
		[0.4129159,0.3765,0.5647,1.0],
		[0.4148728,0.3765,0.6275,0.0],
		[0.4168297,0.3765,0.6275,1.0],
		[0.4187867,0.3765,0.6902,0.0],
		[0.4207436,0.3765,0.6902,1.0],
		[0.4227006,0.3765,0.7529,0.0],
		[0.4246575,0.3765,0.7529,1.0],
		[0.4266145,0.3765,0.8157,0.0],
		[0.4285714,0.3765,0.8157,1.0],
		[0.4305284,0.3765,0.8784,0.0],
		[0.4324853,0.3765,0.8784,1.0],
		[0.4344423,0.3765,0.9412,0.0],
		[0.4363992,0.3765,0.9412,1.0],
		[0.4383562,0.4392,0.0000,0.0],
		[0.4403131,0.4392,0.0000,1.0],
		[0.4422701,0.4392,0.0627,0.0],
		[0.4442270,0.4392,0.0627,1.0],
		[0.4461840,0.4392,0.1255,0.0],
		[0.4481409,0.4392,0.1255,1.0],
		[0.4500978,0.4392,0.1882,0.0],
		[0.4520548,0.4392,0.1882,1.0],
		[0.4540117,0.4392,0.2510,0.0],
		[0.4559687,0.4392,0.2510,1.0],
		[0.4579256,0.4392,0.3137,0.0],
		[0.4598826,0.4392,0.3137,1.0],
		[0.4618395,0.4392,0.3765,0.0],
		[0.4637965,0.4392,0.3765,1.0],
		[0.4657534,0.4392,0.4392,0.0],
		[0.4677104,0.4392,0.4392,1.0],
		[0.4696673,0.4392,0.5020,0.0],
		[0.4716243,0.4392,0.5020,1.0],
		[0.4735812,0.4392,0.5647,0.0],
		[0.4755382,0.4392,0.5647,1.0],
		[0.4774951,0.4392,0.6275,0.0],
		[0.4794521,0.4392,0.6275,1.0],
		[0.4814090,0.4392,0.6902,0.0],
		[0.4833659,0.4392,0.6902,1.0],
		[0.4853229,0.4392,0.7529,0.0],
		[0.4872798,0.4392,0.7529,1.0],
		[0.4892368,0.4392,0.8157,0.0],
		[0.4911937,0.4392,0.8157,1.0],
		[0.4931507,0.4392,0.8784,0.0],
		[0.4951076,0.4392,0.8784,1.0],
		[0.4970646,0.4392,0.9412,0.0],
		[0.4990215,0.4392,0.9412,1.0],
		[0.5009785,0.5020,0.0000,0.0],
		[0.5029354,0.5020,0.0000,1.0],
		[0.5048924,0.5020,0.0627,0.0],
		[0.5068493,0.5020,0.0627,1.0],
		[0.5088063,0.5020,0.1255,0.0],
		[0.5107632,0.5020,0.1255,1.0],
		[0.5127202,0.5020,0.1882,0.0],
		[0.5146771,0.5020,0.1882,1.0],
		[0.5166341,0.5020,0.2510,0.0],
		[0.5185910,0.5020,0.2510,1.0],
		[0.5205479,0.5020,0.3137,0.0],
		[0.5225049,0.5020,0.3137,1.0],
		[0.5244618,0.5020,0.3765,0.0],
		[0.5264188,0.5020,0.3765,1.0],
		[0.5283757,0.5020,0.4392,0.0],
		[0.5303327,0.5020,0.4392,1.0],
		[0.5322896,0.5020,0.5020,0.0],
		[0.5342466,0.5020,0.5020,1.0],
		[0.5362035,0.5020,0.5647,0.0],
		[0.5381605,0.5020,0.5647,1.0],
		[0.5401174,0.5020,0.6275,0.0],
		[0.5420744,0.5020,0.6275,1.0],
		[0.5440313,0.5020,0.6902,0.0],
		[0.5459883,0.5020,0.6902,1.0],
		[0.5479452,0.5020,0.7529,0.0],
		[0.5499022,0.5020,0.7529,1.0],
		[0.5518591,0.5020,0.8157,0.0],
		[0.5538160,0.5020,0.8157,1.0],
		[0.5557730,0.5020,0.8784,0.0],
		[0.5577299,0.5020,0.8784,1.0],
		[0.5596869,0.5020,0.9412,0.0],
		[0.5616438,0.5020,0.9412,1.0],
		[0.5636008,0.5647,0.0000,0.0],
		[0.5655577,0.5647,0.0000,1.0],
		[0.5675147,0.5647,0.0627,0.0],
		[0.5694716,0.5647,0.0627,1.0],
		[0.5714286,0.5647,0.1255,0.0],
		[0.5733855,0.5647,0.1255,1.0],
		[0.5753425,0.5647,0.1882,0.0],
		[0.5772994,0.5647,0.1882,1.0],
		[0.5792564,0.5647,0.2510,0.0],
		[0.5812133,0.5647,0.2510,1.0],
		[0.5831703,0.5647,0.3137,0.0],
		[0.5851272,0.5647,0.3137,1.0],
		[0.5870841,0.5647,0.3765,0.0],
		[0.5890411,0.5647,0.3765,1.0],
		[0.5909980,0.5647,0.4392,0.0],
		[0.5929550,0.5647,0.4392,1.0],
		[0.5949119,0.5647,0.5020,0.0],
		[0.5968689,0.5647,0.5020,1.0],
		[0.5988258,0.5647,0.5647,0.0],
		[0.6007828,0.5647,0.5647,1.0],
		[0.6027397,0.5647,0.6275,0.0],
		[0.6046967,0.5647,0.6275,1.0],
		[0.6066536,0.5647,0.6902,0.0],
		[0.6086106,0.5647,0.6902,1.0],
		[0.6105675,0.5647,0.7529,0.0],
		[0.6125245,0.5647,0.7529,1.0],
		[0.6144814,0.5647,0.8157,0.0],
		[0.6164384,0.5647,0.8157,1.0],
		[0.6183953,0.5647,0.8784,0.0],
		[0.6203523,0.5647,0.8784,1.0],
		[0.6223092,0.5647,0.9412,0.0],
		[0.6242661,0.5647,0.9412,1.0],
		[0.6262231,0.6275,0.0000,0.0],
		[0.6281800,0.6275,0.0000,1.0],
		[0.6301370,0.6275,0.0627,0.0],
		[0.6320939,0.6275,0.0627,1.0],
		[0.6340509,0.6275,0.1255,0.0],
		[0.6360078,0.6275,0.1255,1.0],
		[0.6379648,0.6275,0.1882,0.0],
		[0.6399217,0.6275,0.1882,1.0],
		[0.6418787,0.6275,0.2510,0.0],
		[0.6438356,0.6275,0.2510,1.0],
		[0.6457926,0.6275,0.3137,0.0],
		[0.6477495,0.6275,0.3137,1.0],
		[0.6497065,0.6275,0.3765,0.0],
		[0.6516634,0.6275,0.3765,1.0],
		[0.6536204,0.6275,0.4392,0.0],
		[0.6555773,0.6275,0.4392,1.0],
		[0.6575342,0.6275,0.5020,0.0],
		[0.6594912,0.6275,0.5020,1.0],
		[0.6614481,0.6275,0.5647,0.0],
		[0.6634051,0.6275,0.5647,1.0],
		[0.6653620,0.6275,0.6275,0.0],
		[0.6673190,0.6275,0.6275,1.0],
		[0.6692759,0.6275,0.6902,0.0],
		[0.6712329,0.6275,0.6902,1.0],
		[0.6731898,0.6275,0.7529,0.0],
		[0.6751468,0.6275,0.7529,1.0],
		[0.6771037,0.6275,0.8157,0.0],
		[0.6790607,0.6275,0.8157,1.0],
		[0.6810176,0.6275,0.8784,0.0],
		[0.6829746,0.6275,0.8784,1.0],
		[0.6849315,0.6275,0.9412,0.0],
		[0.6868885,0.6275,0.9412,1.0],
		[0.6888454,0.6902,0.0000,0.0],
		[0.6908023,0.6902,0.0000,1.0],
		[0.6927593,0.6902,0.0627,0.0],
		[0.6947162,0.6902,0.0627,1.0],
		[0.6966732,0.6902,0.1255,0.0],
		[0.6986301,0.6902,0.1255,1.0],
		[0.7005871,0.6902,0.1882,0.0],
		[0.7025440,0.6902,0.1882,1.0],
		[0.7045010,0.6902,0.2510,0.0],
		[0.7064579,0.6902,0.2510,1.0],
		[0.7084149,0.6902,0.3137,0.0],
		[0.7103718,0.6902,0.3137,1.0],
		[0.7123288,0.6902,0.3765,0.0],
		[0.7142857,0.6902,0.3765,1.0],
		[0.7162427,0.6902,0.4392,0.0],
		[0.7181996,0.6902,0.4392,1.0],
		[0.7201566,0.6902,0.5020,0.0],
		[0.7221135,0.6902,0.5020,1.0],
		[0.7240705,0.6902,0.5647,0.0],
		[0.7260274,0.6902,0.5647,1.0],
		[0.7279843,0.6902,0.6275,0.0],
		[0.7299413,0.6902,0.6275,1.0],
		[0.7318982,0.6902,0.6902,0.0],
		[0.7338552,0.6902,0.6902,1.0],
		[0.7358121,0.6902,0.7529,0.0],
		[0.7377691,0.6902,0.7529,1.0],
		[0.7397260,0.6902,0.8157,0.0],
		[0.7416830,0.6902,0.8157,1.0],
		[0.7436399,0.6902,0.8784,0.0],
		[0.7455969,0.6902,0.8784,1.0],
		[0.7475538,0.6902,0.9412,0.0],
		[0.7495108,0.6902,0.9412,1.0],
		[0.7514677,0.7529,0.0000,0.0],
		[0.7534247,0.7529,0.0000,1.0],
		[0.7553816,0.7529,0.0627,0.0],
		[0.7573386,0.7529,0.0627,1.0],
		[0.7592955,0.7529,0.1255,0.0],
		[0.7612524,0.7529,0.1255,1.0],
		[0.7632094,0.7529,0.1882,0.0],
		[0.7651663,0.7529,0.1882,1.0],
		[0.7671233,0.7529,0.2510,0.0],
		[0.7690802,0.7529,0.2510,1.0],
		[0.7710372,0.7529,0.3137,0.0],
		[0.7729941,0.7529,0.3137,1.0],
		[0.7749511,0.7529,0.3765,0.0],
		[0.7769080,0.7529,0.3765,1.0],
		[0.7788650,0.7529,0.4392,0.0],
		[0.7808219,0.7529,0.4392,1.0],
		[0.7827789,0.7529,0.5020,0.0],
		[0.7847358,0.7529,0.5020,1.0],
		[0.7866928,0.7529,0.5647,0.0],
		[0.7886497,0.7529,0.5647,1.0],
		[0.7906067,0.7529,0.6275,0.0],
		[0.7925636,0.7529,0.6275,1.0],
		[0.7945205,0.7529,0.6902,0.0],
		[0.7964775,0.7529,0.6902,1.0],
		[0.7984344,0.7529,0.7529,0.0],
		[0.8003914,0.7529,0.7529,1.0],
		[0.8023483,0.7529,0.8157,0.0],
		[0.8043053,0.7529,0.8157,1.0],
		[0.8062622,0.7529,0.8784,0.0],
		[0.8082192,0.7529,0.8784,1.0],
		[0.8101761,0.7529,0.9412,0.0],
		[0.8121331,0.7529,0.9412,1.0],
		[0.8140900,0.8157,0.0000,0.0],
		[0.8160470,0.8157,0.0000,1.0],
		[0.8180039,0.8157,0.0627,0.0],
		[0.8199609,0.8157,0.0627,1.0],
		[0.8219178,0.8157,0.1255,0.0],
		[0.8238748,0.8157,0.1255,1.0],
		[0.8258317,0.8157,0.1882,0.0],
		[0.8277886,0.8157,0.1882,1.0],
		[0.8297456,0.8157,0.2510,0.0],
		[0.8317025,0.8157,0.2510,1.0],
		[0.8336595,0.8157,0.3137,0.0],
		[0.8356164,0.8157,0.3137,1.0],
		[0.8375734,0.8157,0.3765,0.0],
		[0.8395303,0.8157,0.3765,1.0],
		[0.8414873,0.8157,0.4392,0.0],
		[0.8434442,0.8157,0.4392,1.0],
		[0.8454012,0.8157,0.5020,0.0],
		[0.8473581,0.8157,0.5020,1.0],
		[0.8493151,0.8157,0.5647,0.0],
		[0.8512720,0.8157,0.5647,1.0],
		[0.8532290,0.8157,0.6275,0.0],
		[0.8551859,0.8157,0.6275,1.0],
		[0.8571429,0.8157,0.6902,0.0],
		[0.8590998,0.8157,0.6902,1.0],
		[0.8610568,0.8157,0.7529,0.0],
		[0.8630137,0.8157,0.7529,1.0],
		[0.8649706,0.8157,0.8157,0.0],
		[0.8669276,0.8157,0.8157,1.0],
		[0.8688845,0.8157,0.8784,0.0],
		[0.8708415,0.8157,0.8784,1.0],
		[0.8727984,0.8157,0.9412,0.0],
		[0.8747554,0.8157,0.9412,1.0],
		[0.8767123,0.8784,0.0000,0.0],
		[0.8786693,0.8784,0.0000,1.0],
		[0.8806262,0.8784,0.0627,0.0],
		[0.8825832,0.8784,0.0627,1.0],
		[0.8845401,0.8784,0.1255,0.0],
		[0.8864971,0.8784,0.1255,1.0],
		[0.8884540,0.8784,0.1882,0.0],
		[0.8904110,0.8784,0.1882,1.0],
		[0.8923679,0.8784,0.2510,0.0],
		[0.8943249,0.8784,0.2510,1.0],
		[0.8962818,0.8784,0.3137,0.0],
		[0.8982387,0.8784,0.3137,1.0],
		[0.9001957,0.8784,0.3765,0.0],
		[0.9021526,0.8784,0.3765,1.0],
		[0.9041096,0.8784,0.4392,0.0],
		[0.9060665,0.8784,0.4392,1.0],
		[0.9080235,0.8784,0.5020,0.0],
		[0.9099804,0.8784,0.5020,1.0],
		[0.9119374,0.8784,0.5647,0.0],
		[0.9138943,0.8784,0.5647,1.0],
		[0.9158513,0.8784,0.6275,0.0],
		[0.9178082,0.8784,0.6275,1.0],
		[0.9197652,0.8784,0.6902,0.0],
		[0.9217221,0.8784,0.6902,1.0],
		[0.9236791,0.8784,0.7529,0.0],
		[0.9256360,0.8784,0.7529,1.0],
		[0.9275930,0.8784,0.8157,0.0],
		[0.9295499,0.8784,0.8157,1.0],
		[0.9315068,0.8784,0.8784,0.0],
		[0.9334638,0.8784,0.8784,1.0],
		[0.9354207,0.8784,0.9412,0.0],
		[0.9373777,0.8784,0.9412,1.0],
		[0.9393346,0.9412,0.0000,0.0],
		[0.9412916,0.9412,0.0000,1.0],
		[0.9432485,0.9412,0.0627,0.0],
		[0.9452055,0.9412,0.0627,1.0],
		[0.9471624,0.9412,0.1255,0.0],
		[0.9491194,0.9412,0.1255,1.0],
		[0.9510763,0.9412,0.1882,0.0],
		[0.9530333,0.9412,0.1882,1.0],
		[0.9549902,0.9412,0.2510,0.0],
		[0.9569472,0.9412,0.2510,1.0],
		[0.9589041,0.9412,0.3137,0.0],
		[0.9608611,0.9412,0.3137,1.0],
		[0.9628180,0.9412,0.3765,0.0],
		[0.9647750,0.9412,0.3765,1.0],
		[0.9667319,0.9412,0.4392,0.0],
		[0.9686888,0.9412,0.4392,1.0],
		[0.9706458,0.9412,0.5020,0.0],
		[0.9726027,0.9412,0.5020,1.0],
		[0.9745597,0.9412,0.5647,0.0],
		[0.9765166,0.9412,0.5647,1.0],
		[0.9784736,0.9412,0.6275,0.0],
		[0.9804305,0.9412,0.6275,1.0],
		[0.9823875,0.9412,0.6902,0.0],
		[0.9843444,0.9412,0.6902,1.0],
		[0.9863014,0.9412,0.7529,0.0],
		[0.9882583,0.9412,0.7529,1.0],
		[0.9902153,0.9412,0.8157,0.0],
		[0.9921722,0.9412,0.8157,1.0],
		[0.9941292,0.9412,0.8784,0.0],
		[0.9960861,0.9412,0.8784,1.0],
		[0.9980431,0.9412,0.9412,0.0],
		[1.0000000,0.9412,0.9412,1.0]
	]
}
export default colorUtil